export const MOST_COMMON_LABEL_SUFFIX = ' (most common)';
